export const getEnvironment = () => {
	return {
		env: window.globalEnv ? window.globalEnv.env : "DEVELOPMENT",
		region: window.globalEnv ? window.globalEnv.region : "EXTERNAL",
		basePath: window.globalEnv ? window.globalEnv.basePath : "/"
	};
};
